module.exports = __webpack_public_path__ + "static/media/icon-campaigns.b670a57d.svg";